import { OrderType } from '@/shared/types/product-types'

export const isDiscountProductBuy = (orderType?: OrderType): boolean =>
	orderType === OrderType.Order ||
	orderType === OrderType.PreOrder ||
	orderType === OrderType.Prereservation ||
	orderType === OrderType.Reservation ||
	orderType === OrderType.TCP
